'use client'

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material'
import { useTranslations } from 'next-intl'

type ShareLinkDialogProps = {
  /** The link to show; the dialog is closed while this is undefined. */
  link?: string
  onClose: () => void
}

/** Shows a shared conversation's link to copy by hand where the browser refuses clipboard access. */
export default function ShareLinkDialog({ link, onClose }: ShareLinkDialogProps) {
  const t = useTranslations('features.AssistantV2')

  return (
    <Dialog open={link !== undefined} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('shareDialogTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{t('shareDialogHint')}</DialogContentText>
        <TextField
          fullWidth
          size="small"
          value={link ?? ''}
          onFocus={(event) => event.target.select()}
          slotProps={{ htmlInput: { readOnly: true, 'aria-label': t('shareDialogTitle') } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('shareDialogDone')}</Button>
      </DialogActions>
    </Dialog>
  )
}
